export default __webpack_public_path__ + "static/media/f_4.9183aba5.jpg";